import queryString from 'query-string';

import App from '../../../models/app';
import { os } from 'config';

export const getContactUrl = (app: App, phoneAppVersion?: string, deviceName?: string) => {
  const { buildId, contactUrl, contactEmail, id, name, versionString } = app;
  let url = contactUrl;
  if (contactUrl && contactUrl.startsWith('http')) {
    const urlObject = new URL(contactUrl);
    const params = queryString.parse(urlObject.search);
    urlObject.search = queryString.stringify({
      applicationId: id,
      applicationName: name,
      buildId,
      hostOS: os,
      hostAppVersion: phoneAppVersion || 'N/A',
      versionString,
      ...params
    });
    url = urlObject.toString();
  } else if (contactEmail) {
    url = `mailto:${contactEmail}?${queryString.stringify({
      subject: `Support request for Fitbit application: ${name} on ${deviceName}`
    })}`;
  }

  return url;
}